import * as PrimitiveDialog from '@radix-ui/react-dialog'

import { cn } from '~/utils/cn'

type SideSheetContentProps = React.ComponentPropsWithRef<
  typeof PrimitiveDialog.Content
> & {
  showOverlay?: boolean
}

function SideSheetContent({
  showOverlay = true,
  ...props
}: SideSheetContentProps) {
  const animationClasses = cn(
    'data-[state=open]:fade-in-20 data-[state=open]:slide-in-from-right data-[state=open]:animate-in data-[state=open]:duration-300 data-[state=open]:ease-out',
    'data-[state=closed]:fade-out data-[state=closed]:slide-out-to-right data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=closed]:ease-in-out'
  )

  return (
    <PrimitiveDialog.Portal>
      {showOverlay && (
        <PrimitiveDialog.Overlay
          className={cn(
            'fixed inset-0 bg-[var(--color-labeling-fill-principal-default)] opacity-[calc(var(--opacity-low)_*_0.01)] ease-in-out',
            'data-[state=open]:fade-in-20 data-[state=open]:animate-in',
            'data-[state=closed]:fade-out data-[state=closed]:animate-out'
          )}
        />
      )}
      <PrimitiveDialog.Content
        {...props}
        style={
          {
            '--sheet-padding': '1rem',
            '--sheet-height': 'calc(100vh - (var(--sheet-padding) * 2))',
            '--sheet-max-width': '30rem',
            '--sheet-min-width': '22.5rem',
          } as Record<string, string | React.CSSProperties>
        }
        className={cn(
          'z-10 h-[var(--sheet-height)] max-h-[var(--sheet-max-height)] min-w-[var(--sheet-min-width)] max-w-[--sheet-max-width] space-y-4',
          'rounded-[var(--border-radius-mediumcontainer)] border-0',
          'fixed top-[var(--sheet-padding)] right-[var(--sheet-padding)] overflow-y-auto bg-[var(--color-container-fill-default)]',
          animationClasses
        )}
        data-slot="side-sheet-content"
      />
    </PrimitiveDialog.Portal>
  )
}

export { SideSheetContent }
